<template>
    <div class="settings-access-center">
        <h1 class="app-hub-page-title">系统配置</h1>
        <el-tabs
            v-model="activeSection"
            type="border-card"
            class="settings-access-center__tabs"
            @tab-click="handleSectionClick"
        >
            <el-tab-pane label="基础信息" name="basic" lazy>
                <div class="settings-access-center__pane">
                    <settings-basic-info :embedded="true" />
                </div>
            </el-tab-pane>
            <el-tab-pane label="登录页" name="login" lazy>
                <div class="settings-access-center__pane">
                    <settings-login-page />
                </div>
            </el-tab-pane>
            <el-tab-pane label="快登配置" name="quick" lazy>
                <div class="settings-access-center__pane">
                    <settings-quick-links :embedded="true" />
                </div>
            </el-tab-pane>
            <el-tab-pane label="权限与子账号" name="access" lazy>
                <div class="settings-access-center__pane settings-access-center__inner-wrap">
                    <div class="settings-access-center__inner-actions">
                        <el-button
                            type="primary"
                            size="small"
                            icon="el-icon-plus"
                            @click="openEmbeddedUserCreate"
                        >
                            新增子账号
                        </el-button>
                        <el-button
                            type="default"
                            size="small"
                            icon="el-icon-plus"
                            @click="openEmbeddedRoleCreate"
                        >
                            新增角色
                        </el-button>
                    </div>
                    <el-tabs
                        v-model="activeAccessTab"
                        type="card"
                        class="settings-access-center__inner-tabs"
                        @tab-click="handleAccessTabClick"
                    >
                        <el-tab-pane label="子账号管理" name="users" lazy>
                            <settings-users ref="embeddedUsers" :embedded="true" :hide-create-button="true" :hide-toolbar="true" />
                        </el-tab-pane>
                        <el-tab-pane label="权限配置" name="roles" lazy>
                            <settings-roles ref="embeddedRoles" :embedded="true" :hide-create-button="true" :hide-toolbar="true" />
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-tab-pane>
            <el-tab-pane label="系统入口" name="entry" lazy>
                <div class="settings-access-center__pane">
                    <system-entry-config />
                </div>
            </el-tab-pane>
            <el-tab-pane label="API配置" name="api" lazy>
                <div class="settings-access-center__pane">
                    <settings-api-config />
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import SettingsBasicInfo from './SettingsBasicInfo.vue';
import SettingsQuickLinks from './SettingsQuickLinks.vue';
import SettingsRoles from './SettingsRoles.vue';
import SettingsUsers from './SettingsUsers.vue';
import SystemEntryConfig from './SystemEntryConfig.vue';
import SettingsApiConfig from './SettingsApiConfig.vue';
import SettingsLoginPage from './SettingsLoginPage.vue';

export default {
    name: 'SettingsAccessCenter',
    components: {
        SettingsBasicInfo: SettingsBasicInfo,
        SettingsLoginPage: SettingsLoginPage,
        SettingsQuickLinks: SettingsQuickLinks,
        SettingsRoles: SettingsRoles,
        SettingsUsers: SettingsUsers,
        SystemEntryConfig: SystemEntryConfig,
        SettingsApiConfig: SettingsApiConfig
    },
    data() {
        return {
            activeSection: 'basic',
            activeAccessTab: 'roles'
        };
    },
    watch: {
        '$route.query': {
            immediate: true,
            handler: function (query) {
                var section = query && query.section ? query.section : '';
                var tab = query && query.tab ? query.tab : '';

                if (section === 'partners') {
                    this.$router.replace({ name: 'field-partners' }).catch(function () {});
                    return;
                }

                if (section === 'quick' || section === 'access' || section === 'basic' || section === 'login' || section === 'entry' || section === 'api') {
                    this.activeSection = section;
                } else if (tab === 'users' || tab === 'roles') {
                    this.activeSection = 'access';
                } else {
                    this.activeSection = 'basic';
                }

                if (tab === 'users') {
                    this.activeAccessTab = 'users';
                } else {
                    this.activeAccessTab = 'roles';
                }
            }
        }
    },
    methods: {
        replaceQuery: function (nextQuery) {
            this.$router.replace({
                path: this.$route.path,
                query: nextQuery
            }).catch(function () {
            });
        },
        handleSectionClick: function (tab) {
            var section = tab.name || this.activeSection;
            var nextQuery = Object.assign({}, this.$route.query);
            if (section === 'access') {
                nextQuery.section = 'access';
                nextQuery.tab = this.activeAccessTab || 'roles';
            } else {
                nextQuery.section = section;
                delete nextQuery.tab;
            }

            if (this.$route.query.section === nextQuery.section && this.$route.query.tab === nextQuery.tab) {
                return;
            }
            this.replaceQuery(nextQuery);
        },
        handleAccessTabClick: function (tab) {
            var name = tab.name || this.activeAccessTab;
            var nextQuery = Object.assign({}, this.$route.query, {
                section: 'access',
                tab: name
            });
            if (this.$route.query.section === nextQuery.section && this.$route.query.tab === nextQuery.tab) {
                return;
            }
            this.replaceQuery(nextQuery);
        },
        openEmbeddedUserCreate: function () {
            var _this = this;
            if (this.activeAccessTab !== 'users') {
                this.activeAccessTab = 'users';
                this.replaceQuery(Object.assign({}, this.$route.query, { section: 'access', tab: 'users' }));
            }
            this.$nextTick(function () {
                var comp = _this.$refs.embeddedUsers;
                if (comp && typeof comp.openCreateDialog === 'function') {
                    comp.openCreateDialog();
                }
            });
        },
        openEmbeddedRoleCreate: function () {
            var _this = this;
            if (this.activeAccessTab !== 'roles') {
                this.activeAccessTab = 'roles';
                this.replaceQuery(Object.assign({}, this.$route.query, { section: 'access', tab: 'roles' }));
            }
            this.$nextTick(function () {
                var comp = _this.$refs.embeddedRoles;
                if (comp && typeof comp.openRoleDialog === 'function') {
                    comp.openRoleDialog();
                }
            });
        }
    }
};
</script>

<style scoped>
.settings-access-center {
    padding: 16px 18px 20px;
}

.settings-access-center__tabs /deep/ .el-tabs__header {
    margin: 0;
    background: #fff;
}

.settings-access-center__tabs /deep/ .el-tabs__item {
    height: 44px;
    line-height: 44px;
    font-size: 13px;
    color: #5b6573;
}

.settings-access-center__tabs /deep/ .el-tabs__item.is-active {
    color: #2f79ff;
    font-weight: 600;
}

.settings-access-center__tabs /deep/ .el-tabs__content {
    padding: 18px;
    background: #f6f8fc;
}

.settings-access-center__pane {
    border: 1px solid #e6ebf3;
    border-radius: 10px;
    background: #fff;
    padding: 16px;
}

.settings-access-center__inner-tabs {
    margin-top: 0;
}

.settings-access-center__inner-wrap {
    position: relative;
}

.settings-access-center__inner-actions {
    margin-bottom: 10px;
}

.settings-access-center__inner-tabs /deep/ .el-tabs__header {
    display: block;
    margin: 0 0 10px;
    border-bottom: 1px solid #e6ebf3;
}

.settings-access-center__inner-tabs /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #e6ebf3;
}

.settings-access-center__inner-tabs /deep/ .el-tabs__item {
    height: 36px;
    line-height: 36px;
    color: #5b6573;
}

.settings-access-center__inner-tabs /deep/ .el-tabs__item.is-active {
    color: #2f79ff;
    font-weight: 600;
}

.settings-access-center__tabs /deep/ .settings-basic-info-page,
.settings-access-center__tabs /deep/ .settings-quick-links-page,
.settings-access-center__tabs /deep/ .quick-link-manager-page,
.settings-access-center__tabs /deep/ .settings-roles-page,
.settings-access-center__tabs /deep/ .settings-users-page,
.settings-access-center__tabs /deep/ .settings-api-config,
.settings-access-center__tabs /deep/ .settings-login-page {
    padding: 0;
}

.settings-access-center__tabs /deep/ .el-card {
    border: 1px solid #e6ebf3;
    border-radius: 10px;
    box-shadow: none;
}

.settings-access-center__tabs /deep/ .el-card__body {
    padding: 16px;
}

.settings-access-center__tabs /deep/ .el-table th {
    background: #f7f9fd;
    color: #4f5b6a;
}

.settings-access-center__tabs /deep/ .el-table td,
.settings-access-center__tabs /deep/ .el-table th {
    padding-top: 9px;
    padding-bottom: 9px;
}

.settings-access-center__tabs /deep/ .el-form-item__label {
    color: #4f5b6a;
}

.settings-access-center__tabs /deep/ .el-button + .el-button {
    margin-left: 10px;
}

.settings-access-center__tabs /deep/ .el-input__inner,
.settings-access-center__tabs /deep/ .el-textarea__inner {
    border-radius: 6px;
}

.settings-access-center__tabs /deep/ .el-button--small {
    border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/SettingsAccessCenter.vue